import {useLocaleStore} from "~/plugins/store/locale";
import {createDefaultLocale} from "~/types/Locale";

export default defineNuxtRouteMiddleware(async (to) => {
    const localeStore = useLocaleStore(); // Accesăm store-ul pentru localizare
    const defaultLocale = createDefaultLocale(); // Obținem localizarea implicită
    const locales = await localeStore.getLocales(); // Obținem lista de localizări suportate
    // Extragem localizarea din URL (dacă există)
    const segments = to.path.split('/').filter(Boolean);
    const currentLocaleCode = segments[0]; // Prima parte a URL-ului

    // Dacă URL-ul nu conține o localizare
    if (!locales.some((locale) => locale.code === currentLocaleCode)) {
        // Nu modificăm `localeStore.currentLocale`, doar continuăm
        return;
    }

    // Dacă localizarea este validă, o eliminăm din URL
    if (currentLocaleCode) {
        const activeLocale = locales.find((locale) => locale.code === currentLocaleCode);
        // Dacă localizarea este validă și diferită de cea implicită, setăm localizarea curentă în store
        await localeStore.setCurrentLocale(activeLocale || defaultLocale);
        const newPath = '/' + segments.slice(1).join('/');

        // Evităm bucla verificând dacă URL-ul este deja corect
        if (to.path !== newPath) {
            return navigateTo(newPath || '/', { replace: true }); // Redirecționăm la "/" dacă URL-ul rămâne gol
        }
    }
});
